import React, { Component } from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import RegionsAll from "../components/regions/all-regions";
import RegionSingle from "../components/regions/single-region";
import { Router, navigate } from "@reach/router";

const workType = ["art", "writing"];

export class RegionsContainer extends Component {
  state = {
    country: "USA",
    zip: "",
    noZip: false,
    interest: 0,
    regions: [],
    documents: [],
    navSection: false,
  };

  toggleSection = () => {
    this.setState({ navSection: !this.state.navSection });
  };

  async queueAsyncFns(fns) {
    const values = [];
    await fns.reduce((previous, current, index, array) => {
      const thenable = index === 1 ? previous() : previous;
      return thenable.then((value) => {
        values.push(value);
        return index === array.length - 1
          ? current().then((value) => values.push(value))
          : current();
      });
    });
    return values;
  }

  getRegions = async (country, zip) => {
    console.log(`getRegions async`)
    try {
      const response = await fetch(
        `${process.env.GATSBY_PORTAL_REGION}/zip/${zip}?country=${country}`
      );
      return await response.json();
    } catch (error) {
      console.error("Error fetching regions:", error);
      return [];
    }
  };

  getSingleRegion = async (code) => {
    console.log('getSingleRegion async', code);
    try {
      const response = await fetch(`${process.env.GATSBY_PORTAL_REGION}/${code}`);
      return await response.json();
    } catch (error) {
      console.error("Error fetching single region:", error);
      return {};
    }
  };

  getBothRegions = async (country, zip, interest) => {
    console.log(`getBothRegions async`);
    try {
      const regionCodes = await this.queueAsyncFns(
        workType.map(() => () => this.getRegions(country, zip))
      );

      console.log(`fetched both regions, ${regionCodes}`);
      // continue localStor for zip
      // localStorage.setItem("zip", zip);

      const bothRegions = await this.queueAsyncFns(
        regionCodes.map((code) => () => this.getSingleRegion(code.regionShortCode))
      );

      if (!bothRegions[interest].regionShortCode) {
        console.log(`no shortcode in interest index? - direct migration?`)
        this.setState({ noZip: true });
      } else {
        this.setState(
          { regions: bothRegions, documents: bothRegions[interest].documents || [] },
          () => {
            navigate(`/regions/${bothRegions[interest].regionShortCode}`, {
              state: {
                regions: bothRegions,
                documents: bothRegions[interest].documents || [],
              },
            });
          }
        );
      }
    } catch (error) {
      console.error("Error fetching both regions:", error);
    }
  };

  handleCountryChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleZipChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    //   , () => {
    //   // localStorage.setItem("zip", e.target.value);
    //   this.setState({ [e.target.name]: e.target.value });
    // });
  };

  handleInterestChange = (e) => {
    this.setState({ [e.target.name]: parseInt(e.target.value) });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ noZip: false });
    // localStorage.setItem("zip", this.state.zip);
    console.log(`state of zip = ${this.state.zip}`);

    try {
      const regionsFromZips = await this.getRegions(this.state.country, this.state.zip);
      if (regionsFromZips.regions?.length > 0) {
        const selectedRegion = regionsFromZips.regions[this.state.interest];

        console.log(`selectedRegion = ${JSON.stringify(selectedRegion, null, 2)}`);

        const regionData = await this.getSingleRegion(selectedRegion.code);
        this.setState(
          { regions: regionsFromZips.regions, documents: regionData.documents || [] },
          () => {
            navigate(`/regions/${selectedRegion.code}`, {
              state: {
                regions: regionsFromZips.regions,
                documents: regionData.documents,
              },
            });
          }
        );
      }
    } catch (error) {
      console.error("Error during form submission:", error);
    }
  };

  findRegion = () => {
    navigate("/regions");
  };

  switchRegion = async () => {
    console.log(`switchRegion called`);

    console.log(`interest = ${this.state.interest}`)
    let newInterest = this.state.interest === 0 ? 1 : 0;
    console.log(`after switch, newInterest = ${newInterest}`);
    const selectedRegion = this.state.regions[newInterest];
    console.log(`regions = ${this.state.regions}`);
    console.log(`selectedRegion in switch region = ${JSON.stringify(selectedRegion, null, 2)}`);
    console.log(`selectedRegion.code = ${selectedRegion.code}`)
    console.log(`selectedRegion.regionShortCode = ${selectedRegion.regionShortCode}`)

    if (!selectedRegion) {
      console.error("Error: No region found for new interest.");
      return;
    }

    try {
      // change from await this.getSingleRegion(selectedReigon.regionShortCode) TO
      // await this.getSingleRegion(selectedRegion.code) BELOW
      const newRegionData = await this.getSingleRegion(selectedRegion.code);
      this.setState({
        interest: newInterest,
        selectedRegion: newRegionData,
        documents: newRegionData.documents || [],
      });

      console.log(`updated interest in STATE, ln 175 regions.js, ${this.state.interest}`);

      navigate(`/regions/${selectedRegion.code}`, {
        state: {
          regions: this.state.regions,
          documents: newRegionData.documents || [],
        },
      });
    } catch (error) {
      console.error("Error fetching new region data:", error);
    }
  };

  render() {
    return (
      <Layout toggleSection={this.toggleSection}>
        {this.state.regions.length > 0 ? (
          <Seo
            title={this.state.regions[this.state.interest].name}
            description={`${this.state.regions[this.state.interest].name} is managed by ${this.state.regions[this.state.interest].partnerName}`}
          />
        ) : (
          <Seo title="My Region" description="Find your Region or view all Regions" />
        )}
        <Router>
          <RegionsAll
            path="/regions"
            handleCountryChange={this.handleCountryChange}
            handleZipChange={this.handleZipChange}
            handleInterestChange={this.handleInterestChange}
            handleSubmit={this.handleSubmit}
            noZip={this.state.noZip}
            interest={this.state.interest}
          />
          <RegionSingle
            path="/regions/:id/*"
            regions={this.state.regions}
            documents={this.state.documents}
            interest={this.state.interest}
            zip={this.state.zip}
            findRegion={this.findRegion}
            switchRegion={this.switchRegion}
            navSection={this.state.navSection}
          />
        </Router>
      </Layout>
    );
  }
}

export default RegionsContainer;